/* eslint-disable @next/next/no-img-element */
import { GetAseobiAttiresQuery } from "@src/@types/api.d";
import React from "react";
import styles from "./styles.module.scss";
import getSymbolFromCurrency from "currency-symbol-map";

interface Props {
  item: NonNullable<GetAseobiAttiresQuery["getAseobiAttires"]>[number];
  quantity: number;
  updateQuantity: (delta: number) => void;
}

const AsoebiStep2 = ({ item, quantity, updateQuantity }: Props) => {
  const increaseQuantity = () => updateQuantity(1);
  const decreaseQuantity = () => {
    if (quantity >= 1) updateQuantity(-1);
  };

  return (
    <div className="border-b pt-6 pb-2 pr-2 relative">
      <div className="flex items-center justify-between gap-2 sm:flex-row sm:items-center">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
          <div className="h-20 w-20">
            {item.images && item.images[0] && (
              <img
                src={item.images[0]}
                alt={item.name}
                className="w-full h-full object-cover"
              />
            )}
          </div>
          <div className="w-40 hidden xs:block">
            <p className="mb-2 font-inter">{item.name}</p>
            <p className="text-sm text-gray-500 font-inter">
              <span className="uppercase">
                {getSymbolFromCurrency(item.currency_iso)}
              </span>
              {item.total_price_per_yard.toLocaleString()} per yard
            </p>
          </div>
        </div>

        <div className="border flex items-center gap-4 py-1 px-2 xs:px-4 xs:py-2 border-gray-400 rounded-md">
          <button
            className="font-inter text-lg text-[#3F3F46] cursor-pointer"
            onClick={decreaseQuantity}
            disabled={quantity === 0}
          >
            -
          </button>
          <p className="font-inter text-sm xs:text-base text-[#3F3F46]">
            {quantity}
          </p>
          <button
            className="font-inter text-lg text-[#3F3F46] cursor-pointer"
            onClick={increaseQuantity}
          >
            +
          </button>
        </div>

        <div className="flex justify-end w-28">
          <p className="font-inter">
            <span className="uppercase">
              {getSymbolFromCurrency(item.currency_iso)}
            </span>
            {(item.total_price_per_yard * quantity).toLocaleString()}
          </p>
        </div>
      </div>
      <div className="w-40 xs:hidden block">
        <p className="mb-2 font-inter">{item.name}</p>
        <p className="text-sm text-gray-500 font-inter">
          <span className="uppercase">
            {getSymbolFromCurrency(item.currency_iso)}
          </span>
          {item.total_price_per_yard.toLocaleString()} per yard
        </p>
      </div>
    </div>
  );
};

export default AsoebiStep2;
